import type {SelectOption} from 'client/TeacherDashboard/types';

import type {DueWithinFilter, SkillPathSortValue, SkillPathStatusSegment} from './types';

export const STATUS_SEGMENTS: {value: SkillPathStatusSegment; label: string}[] = [
  {value: 'open', label: 'Open'},
  {value: 'closed', label: 'Closed'},
  {value: 'scheduled', label: 'Scheduled'}
];

export const DUE_WITHIN_FILTER_OPTIONS: ReadonlyArray<SelectOption<DueWithinFilter>> = [
  {value: 'schoolYear', label: 'This school year'},
  {value: 'month', label: 'This month'},
  {value: 'week', label: 'This week'},
  {value: 'custom', label: 'Custom'}
];

export const SORT_OPTIONS: ReadonlyArray<SelectOption<SkillPathSortValue>> = [
  {value: 'recentlyEdited', label: 'Recently Edited'},
  {value: 'dueDate', label: 'Due Date'},
  {value: 'startDate', label: 'Start Date'},
  {value: 'name', label: 'Name'}
];

/**
 * The direction a field starts in when the teacher first picks it
 */
export const DEFAULT_SORT_ORDER: Record<SkillPathSortValue, 'asc' | 'desc'> = {
  recentlyEdited: 'desc',
  dueDate: 'desc',
  startDate: 'desc',
  name: 'asc'
};

/** The All Classes and class-scoped destinations for the Skill Paths view. */
export const ALL_SKILL_PATHS_PATH = '/skill-paths';
export const getClassSkillPathsPath = (classroomId: string): string =>
  `/classes/${classroomId}/skill-paths`;
